module.exports = __webpack_public_path__ + "static/interface-a337136cd09bd6ce065fb7a54ab36f33.png";